const loader = {
    mounted() {
        this.$nextTick(() => {
            document.body.classList.remove("invisible");
        });
    }
}

export default loader;